import { createVuetify } from 'vuetify';
import { mdi } from 'vuetify/iconsets/mdi';
import { VMaskInput } from 'vuetify/labs/VMaskInput';
import IconHome from '../components/icons/IconHome.vue';
import IconSubmission from '../components/icons/IconSubmission.vue';
import IconMaterial from '../components/icons/IconMaterial.vue';
import IconTrade from '../components/icons/IconTrade.vue';
import IconComponent from '../components/icons/IconComponent.vue';
import IconUser from '../components/icons/IconUser.vue';
import IconEnterprise from '../components/icons/IconEnterprise.vue';
import 'vuetify/styles';
import '@mdi/font/css/materialdesignicons.css';
import '../theme/default.styl';

export default createVuetify({
  components: {
    VMaskInput,
  },
  date: {
    locale: {
      en: 'fr-CA',
    },
  },
  defaults: {
    VTextField: { variant: 'underlined' },
    VMaskInput: { variant: 'underlined' },
    VSelect: { variant: 'underlined' },
    VAutocomplete: { variant: 'underlined' },
    VCombobox: { variant: 'underlined' },
    VTextarea: { variant: 'underlined' },
    VFileInput: { variant: 'underlined' },
    VChip: { closeIcon: 'mdi-close' },
    VDataTable: { density: 'comfortable' },
    VDataTableServer: { density: 'comfortable' },
  },
  theme: {
    themes: {
      light: {
        colors: {
          primary: '#162B46',
          secondary: '#f9802f',
          accent: '#82B1FF',
          error: '#FF5252',
          info: '#2196F3',
          success: '#4CAF50',
          warning: '#FFC107',
        },
      },
    },
  },
  icons: {
    aliases: {
      sortAsc: 'mdi-menu-up',
      sortDesc: 'mdi-menu-down',
      iconHome: IconHome,
      iconSubmission: IconSubmission,
      iconMaterial: IconMaterial,
      iconTrade: IconTrade,
      iconComponent: IconComponent,
      iconUser: IconUser,
      iconEnterprise: IconEnterprise,
    },
    sets: { mdi },
  },
});
